/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum PriceType2 {
  FP = "FP",
  EP = "EP",
  FI = "FI",
  NP = "NP",
}

export enum ApplyType2 {
  None = "None",
  Mandatory = "Mandatory",
  Suggested = "Suggested",
}

export enum UnitType2 {
  Unit = "Unit",
  Week = "Week",
  Term = "Term",
  Day = "Day",
}

export enum LineItemCategory2 {
  Course = "Course",
  SalesItem = "SalesItem",
  GroupCourse = "GroupCourse",
}

export enum CategoryType {
  PRW = 1,
}

export enum DurationUnit {
  Week = "Week",
  Day = "Day",
}

export enum PriceType {
  FP = 0,
  EP = 1,
  FI = 2,
  NP = 3,
}

export enum ApplyType {
  None = 0,
  Mandatory = 1,
  Suggested = 2,
}

export enum UnitType {
  Unit = 0,
  Week = 1,
  Term = 2,
  Day = 3,
}

export enum LineItemCategory {
  Course = 0,
  SalesItem = 1,
  GroupCourse = 2,
}

export enum SalesItemType {
  None = 0,
  Tax = 10,
  SystemArticle = 30,
  EnrollmentFee = 35,
  Item = 40,
  Vtm = 45,
  Other = 50,
  Insurance = 60,
  Travel = 70,
  Accommodation = 80,
  Deposit = 85,
  Course = 90,
  CourseSpecific = 100,
  SpecialArticle = 105,
}

export enum SalesItemSubType {
  NoSubtype = 1,
  AgentCommission = 2,
  Discount = 3,
  ExplorePack = 4,
  FunPack = 5,
  SportsOptions = 6,
  Transfer = 7,
  CaxInsurance = 8,
  EnrollmentFee = 9,
  HostFamily = 10,
  HostFamilyExtraNight = 11,
  Hotel = 12,
  NoAccommodation = 13,
  Other = 14,
  Residence = 15,
  ResidenceExtraNight = 16,
  OptionalExcursions = 17,
  PostTours = 18,
  HotelExtraNight = 19,
  ProtectionCoverage = 20,
  Activities = 21,
  Flight = 22,
  ReunionParty = 23,
  Meals = 24,
  TravelInsurance = 25,
  ActivityVouchers = 26,
  AcademicClasses = 27,
  Internship = 28,
  Books = 29,
  AccommodationServices = 30,
  Gadgets = 31,
  Scholarship = 32,
  VisaRelated = 33,
  UniversityCounselling = 34,
  TuitionDeposit = 35,
  AccommodationDeposit = 36,
  WorkAndTravel = 37,
  Item = 38,
  BoatTrainBus = 39,
  ExamExtension = 40,
  VtmCard = 41,
  ArrivalTransfer = 42,
  DepartureTransfer = 43,
  ArrivalAndDeparture = 44,
  Extension = 45,
  Termination = 46,
  LocalTransportation = 47,
  BalanceCleanup = 48,
  Refunds = 50,
  SPINChoice = 51,
  ReferralDiscounts = 52,
  Course = 100,
}

export enum SegmentType {
  Default = 0,
  Course = 1,
  Break = 2,
}

export enum QuoteStatus2 {
  None = 0,
  Draft = 1,
  Preview = 2,
  Email = 3,
  Print = 4,
  WhatsApp = 5,
  EmailAndWhatsApp = 6,
}

export enum QuoteStatus {
  None = "None",
  Draft = "Draft",
  Preview = "Preview",
  Email = "Email",
  Print = "Print",
  WhatsApp = "WhatsApp",
  EmailAndWhatsApp = "EmailAndWhatsApp",
}

export enum PaymentType {
  RecurringMonthlyPayments = "Recurring monthly payments",
  PaymentPlanPayments = "Payment plan payments",
  PaidInFull = "Paid in full",
  PaidInFullWithDiscount = "Paid in full with discount",
  Reserved = "Reserved",
  DeferredPaymentPlan = "Deferred payment plan",
}

export interface EventResponseDto {
  /** @format guid */
  quoteId?: string;
  cdrResponseJson?: string | null;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  extensions?: Record<string, any>;
  [key: string]: any;
}

export interface EventRequestDto {
  /**
   * @format guid
   * @minLength 1
   */
  quoteExternalId: string;
  /** @minLength 1 */
  termsVersion: string;
}

export interface MarketSettingsInfo {
  autoBookingEnabled?: boolean;
}

export interface InitiateOraclePaymentSessionResponseDto {
  sessionData?: string | null;
  sessionId?: string | null;
  correlationId?: string | null;
  merchantReference?: string | null;
}

export interface InitiateOraclePaymentSessionRequestDto {
  /**
   * @format guid
   * @minLength 1
   */
  externalId: string;
  /** @minLength 1 */
  countryCode: string;
  /** @minLength 1 */
  termsVersion: string;
  /** @minLength 1 */
  paymentSource: string;
  /** @minLength 1 */
  paymentReferenceAction: string;
  returnUrl?: string | null;
  /** @format decimal */
  requestedPaymentAmount?: number | null;
  locale?: string | null;
  paymentType?: PaymentType | null;
}

export type PaymentDetailsResponseDto = PaymentDetailsEntity & object;

export interface PaymentDetailsEntity {
  /** @format int64 */
  id?: number;
  source?: string | null;
  /** @format int32 */
  pageLogId?: number;
  /** @format decimal */
  amount?: number;
  currency?: string | null;
  /** @format int32 */
  efComTxLogId?: number;
  priceQuoteId?: string | null;
  opportunityId?: string | null;
  /** @format guid */
  opportunityUuid?: string;
  /** @format guid */
  externalId?: string;
  status?: string | null;
  providerName?: string | null;
  personContactId?: string | null;
  ipAddress?: string | null;
  /** @format date-time */
  insertDate?: string;
  correlationId?: string | null;
  termsVersion?: string | null;
  /** @format guid */
  cdrId?: string | null;
  paymentType?: string | null;
  /** @format decimal */
  appliedDiscount?: number | null;
}

export interface PaymentOptionsResponseDto {
  fullPayment?: FullPaymentOption | null;
  recurringPayment?: RecurringPaymentOption | null;
}

export interface FullPaymentOption {
  /** @format decimal */
  amount?: number;
  /** @format decimal */
  discountAmount?: number;
  currency?: string | null;
}

export interface RecurringPaymentOption {
  installments?: Installment | null;
  reservationPrice?: ReservationPrice | null;
}

export interface Installment {
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  numberOfInstallments?: number;
  currencyCode?: string | null;
  firstInstallmentDueDate?: string | null;
  lastInstallmentDueDate?: string | null;
}

export interface ReservationPrice {
  /** @format decimal */
  amount?: number;
  currency?: string | null;
}

export interface GenerateQuotesResponse {
  message?: string | null;
  quotes?: QuoteResponse[] | null;
}

export interface QuoteResponse {
  name?: string | null;
  pdfUrl?: string | null;
  /** @format int64 */
  id?: number;
  /** @format guid */
  externalId?: string | null;
}

export type PreviewQuotesRequest = QuoteRequest[];

export interface QuoteRequest {
  /** @format guid */
  id?: string;
  isHideDatesInPDF?: boolean;
  validUpTo?: string | null;
  status?: QuoteStatus;
  note?: string | null;
  advancedOptions?: AdvancedOptions | null;
}

export interface AdvancedOptions {
  durationOptions?: DurationOptions | null;
}

export interface DurationOptions {
  isMultiDuration?: boolean;
  extraDurations?: number[] | null;
}

export type CreateQuotesRequest = QuoteRequest[];

export interface ReservationPriceResponse {
  /** @format guid */
  quoteId?: string;
  /** @format decimal */
  amount?: number;
  currency?: string | null;
}

export interface Quote {
  customer?: Customer | null;
  salesUser?: SalesUser | null;
  document?: Document | null;
  general?: General | null;
  segments?: Segment[] | null;
}

export interface Customer {
  firstName?: string | null;
  lastName?: string | null;
  gender?: string | null;
  dob?: string | null;
  countryOfResidence?: string | null;
}

export interface SalesUser {
  salesOffice?: string | null;
  userName?: string | null;
  email?: string | null;
}

export interface Document {
  isHideDatesInPDF?: boolean;
  emailSubject?: string | null;
  pdfName?: string | null;
  pdfUrl?: string | null;
  note?: string | null;
  status?: QuoteStatus2;
}

export interface General {
  /** @format guid */
  id?: string;
  opportunityId?: string | null;
  /** @format guid */
  opportunityUuid?: string | null;
  product?: string | null;
  displayProgram?: string | null;
  program?: string | null;
  market?: string | null;
  language?: string | null;
  brochure?: string | null;
  season?: string | null;
  currency?: string | null;
  price?: Price | null;
  payments?: PaymentInfo[] | null;
  isPublic?: boolean | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  validUpTo?: string;
}

export interface Price {
  /** @format decimal */
  totalPrice?: number;
  /** @format decimal */
  optionalPrice?: number;
}

export interface PaymentInfo {
  payment?: Money | null;
  /** @format date-time */
  madeAt?: string;
  status?: string | null;
  paymentType?: string | null;
  /** @format decimal */
  appliedDiscount?: number | null;
}

export interface Money {
  /** @format decimal */
  amount?: number;
  currency?: string | null;
}

export interface Segment {
  /** @format guid */
  id?: string;
  type?: SegmentType;
  /** @format int32 */
  duration?: number;
  durationText?: string | null;
  destination?: string | null;
  departurePoint?: string | null;
  course?: SegmentCourse | null;
  group?: SegmentGroupCourse | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  note?: string | null;
  price?: Price | null;
  category?: string | null;
  lineItems?: LineItem[] | null;
}

export interface SegmentCourse {
  code?: string | null;
  name?: string | null;
  /** @format decimal */
  price?: number;
}

export interface SegmentGroupCourse {
  id?: string | null;
  code?: string | null;
  sellingEntity?: string | null;
  accommodationType?: SalesItemSubType | null;
  hfArticleCode?: string | null;
  residenceArticleCode?: string | null;
}

export interface LineItem {
  code?: string | null;
  courseType?: string | null;
  sku?: string | null;
  /** @format guid */
  id?: string;
  /** @format guid */
  bundleId?: string | null;
  isBundled?: boolean;
  type?: SalesItemType;
  subType?: SalesItemSubType;
  destination?: string | null;
  departurePoint?: string | null;
  description?: string | null;
  englishDescription?: string | null;
  additionalDescription?: string | null;
  category?: LineItemCategory;
  unitType?: UnitType;
  /** @format int32 */
  order?: number;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** @format decimal */
  price?: number;
  /** @format int32 */
  quantity?: number;
  /** @format int32 */
  days?: number;
  /** @format decimal */
  totalPrice?: number;
  isOptional?: boolean;
  applyType?: ApplyType;
  /** @format guid */
  parentId?: string;
  isPreparationCourse?: boolean;
  priceType?: PriceType;
  isDeleted?: boolean;
  showOnEfCom?: boolean;
  courseCategory?: string | null;
}

export interface GetCourseIntensityUpgradeResponse {
  newPrice?: Money | null;
  sku?: string | null;
}

export interface DurationUpgradesQuoteDraftResponse {
  durationOptions?: DurationOption[] | null;
}

export interface DurationOption {
  duration?: Duration | null;
  /** @format date-time */
  startDateAt?: string;
  /** @format date-time */
  endDateAt?: string;
  /** Total price of all non-optional line items */
  totalPrice?: Money | null;
  /** Total price of all optional line items */
  optionalPrice?: Money | null;
  difference?: UpgradeDifference | null;
}

export interface Duration {
  /** @format int32 */
  value?: number;
  unit?: DurationUnit;
}

export interface UpgradeDifference {
  pricePerWeek?: Money | null;
  duration?: Duration | null;
  totalPrice?: Money | null;
  optionalPrice?: Money | null;
}

export interface Quote2 {
  /** @format guid */
  id?: string;
  /** @format guid */
  opportunityUuid?: string | null;
  product?: string | null;
  program?: string | null;
  market?: string | null;
  language?: string | null;
  isPublic?: boolean | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  validUpTo?: string;
  prices?: Price2 | null;
  payments?: PaymentInfo[] | null;
  customer?: Customer2 | null;
  salesUser?: SalesUser2 | null;
  document?: Document2 | null;
  segments?: Segment2[] | null;
}

export interface Price2 {
  brochure?: string | null;
  season?: string | null;
  totalPrice?: Money | null;
  optionalPrice?: Money | null;
}

export interface Customer2 {
  firstName?: string | null;
  lastName?: string | null;
  gender?: string | null;
  dob?: string | null;
  countryOfResidence?: string | null;
}

export interface SalesUser2 {
  salesOffice?: string | null;
  userName?: string | null;
  email?: string | null;
}

export interface Document2 {
  isHideDatesInPDF?: boolean;
  emailSubject?: string | null;
  pdfName?: string | null;
  pdfUrl?: string | null;
  note?: string | null;
  status?: QuoteStatus2;
}

export interface Segment2 {
  /** @format guid */
  id?: string;
  type?: SegmentType;
  duration?: Duration | null;
  destinationCode?: string | null;
  departurePoint?: string | null;
  course?: SegmentCourse2 | null;
  group?: SegmentGroupCourse | null;
  /** @format date-time */
  startAt?: string | null;
  /** @format date-time */
  endAt?: string | null;
  note?: string | null;
  price?: Price2 | null;
  category?: CategoryType | null;
  lineItems?: LineItem2[] | null;
}

export interface SegmentCourse2 {
  code?: string | null;
  name?: string | null;
  price?: Money | null;
}

export interface LineItem2 {
  /** @format guid */
  id?: string;
  /** @format guid */
  bundleId?: string | null;
  code?: string | null;
  courseType?: string | null;
  sku?: string | null;
  isBundled?: boolean;
  type?: SalesItemType;
  subType?: SalesItemSubType;
  destination?: string | null;
  departurePoint?: string | null;
  description?: string | null;
  englishDescription?: string | null;
  additionalDescription?: string | null;
  category?: LineItemCategory;
  unitType?: UnitType;
  /** @format int32 */
  order?: number;
  /** @format date-time */
  startAt?: string | null;
  /** @format date-time */
  endAt?: string | null;
  price?: Money | null;
  /** @format int32 */
  quantity?: number;
  totalPrice?: Money | null;
  isOptional?: boolean;
  applyType?: ApplyType;
  /** @format guid */
  parentId?: string;
  isPreparationCourse?: boolean;
  priceType?: PriceType;
  isDeleted?: boolean;
  isPublic?: boolean;
  courseCategory?: string | null;
}

export type Operation = OperationBase & {
  value?: any;
};

export interface OperationBase {
  path?: string | null;
  op?: string | null;
  from?: string | null;
}

export interface GroupPriceCalculationResponse {
  /** @format decimal */
  hfPrice?: number;
  /** @format decimal */
  appliedHfDiscount?: number | null;
  /** @format decimal */
  resPrice?: number;
  /** @format decimal */
  appliedResDiscount?: number | null;
}

export interface GroupPriceCalculationRequest {
  group?: GroupDto | null;
  groupCourseCode?: string | null;
  defaultDeparturePointCode?: string | null;
}

export interface GroupDto {
  id?: string | null;
  /** @format guid */
  uuid?: string | null;
  code?: string | null;
  market?: string | null;
  salesOffice?: string | null;
  program?: string | null;
  brochure?: string | null;
  season?: string | null;
  destination?: BaseEntityDto | null;
  country?: string | null;
  currency?: string | null;
  type?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  /** @format int32 */
  numberOfWeeks?: number;
  status?: GroupStatusDto | null;
  sellingEntity?: string | null;
  /** @format int32 */
  estimatedResSize?: number;
  /** @format int32 */
  estimatedHfSize?: number;
  residenceArticleCode?: string | null;
  hfArticleCode?: string | null;
  /** @format int32 */
  size?: number;
  /** @format int32 */
  netBookings?: number;
  tourType?: string | null;
  tourStartDate?: string | null;
  tourEndDate?: string | null;
  flightArrangedBy?: string | null;
  courses?: GroupCourseDto[] | null;
}

export interface BaseEntityDto {
  code?: string | null;
  name?: string | null;
  displayName?: string | null;
}

export interface GroupStatusDto {
  code?: string | null;
  name?: string | null;
}

export interface GroupCourseDto {
  code?: string | null;
  name?: string | null;
  displayName?: string | null;
  sendToEfCom?: boolean;
  /** @format decimal */
  hfPrice?: number | null;
  /** @format decimal */
  resPrice?: number | null;
  openForBooking?: boolean;
  type?: string | null;
  /** @format int32 */
  hoursPerWeek?: number | null;
  groupOffer?: boolean;
  individualOffer?: boolean;
  ageGroup?: string | null;
  groupId?: string | null;
}

/** Response DTO containing residence accommodation capacity status information across multiple articles and weeks. */
export interface ResidenceAccommodationCapacityResponseDto {
  /** Gets or sets the error message if an error occurred during capacity calculation. */
  errorMessage?: string | null;
  /**
   * Gets or sets the capacity status details organized by article code and week code.
   * The outer dictionary key is the article code, and the inner dictionary contains week codes as keys and status values.
   */
  details?: Record<string, Record<string, string>>;
}

export interface InstallmentsResponseDto {
  quoteUUID?: string | null;
  market?: string | null;
  payInFullDiscount?: boolean;
  installments?: InstallmentDetailsDto | null;
}

export interface InstallmentDetailsDto {
  numberOfInstallments?: string | null;
  amount?: string | null;
  currencyCode?: string | null;
  firstInstallmentDueDate?: string | null;
  lastInstallmentDueDate?: string | null;
  items?: InstallmentItemDto[] | null;
}

export interface InstallmentItemDto {
  dueDate?: string | null;
  amount?: string | null;
}

export interface LineItem3 {
  code?: string | null;
  courseType?: string | null;
  sku?: string | null;
  /** @format guid */
  id?: string;
  /** @format guid */
  bundleId?: string | null;
  isBundled?: boolean;
  type?: SalesItemType;
  subType?: SalesItemSubType;
  destination?: string | null;
  departurePoint?: string | null;
  description?: string | null;
  englishDescription?: string | null;
  additionalDescription?: string | null;
  category?: LineItemCategory2;
  courseCategory?: string | null;
  unitType?: UnitType2;
  /** @format int32 */
  order?: number;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** @format decimal */
  price?: number;
  /** @format int32 */
  quantity?: number;
  isQuantityEditable?: boolean;
  /** @format int32 */
  days?: number;
  /** @format decimal */
  totalPrice?: number;
  isOptional?: boolean;
  applyType?: ApplyType2;
  /** @format guid */
  parentId?: string;
  isPreparationCourse?: boolean;
  priceType?: PriceType2;
  isDeleted?: boolean;
  showOnEfCom?: boolean;
  articleSetting?: ArticleSetting | null;
}

export interface ArticleSetting {
  supplierType?: string | null;
  residenceSubtype?: string | null;
  /** @format int32 */
  ageFrom?: number;
  /** @format int32 */
  ageTo?: number;
  roomType?: string | null;
  quality?: string | null;
  isEnsuite?: boolean;
  includedMealPlan?: string | null;
  optionalMealPlan?: string | null;
}

export interface PostSalesItemsResponse {
  salesItem?: LineItem3 | null;
  message?: string | null;
}

export interface PostSalesItemsRequest {
  unmodifiedSalesItem?: LineItem3 | null;
  modifiedSalesItem?: LineItem3 | null;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "https://quotation.sales-core-services.eflangtech.com";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Quotation API
 * @version 1.0.0
 * @baseUrl https://quotation.sales-core-services.eflangtech.com
 * @contact LangTech support <06feadb5.efcom.onmicrosoft.com@emea.teams.ms>
 *
 * Quotation APIs that allow to get, create and modify quotes. Prices for groups are being also calculated using this service. All endpoints accept the [`EF-Flow-ID`](https://api-guidelines.eflangtech.com/#ef-flow-id) parameter in the request header and they will always return the received value as a response header with the same name.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  accommodationCapacity = {
    /**
     * @description This endpoint makes as many calls to salesforce under the hood as many weeks are in the age of provided start/end dates, and aggregates the result in order to provide the final status. This API returns errorMessage and status Unknown in case there was an error in figuring out the capacity status.
     *
     * @tags Accommodations
     * @name AccommodationsGetAccommodationCapacity
     * @summary Provides accommodation free capacity status for given gender, age and accommodation code.
     * @request GET:/accommodation-capacity
     * @secure
     */
    accommodationsGetAccommodationCapacity: (
      query: {
        /**
         * The accommodation article code identifier.
         * @example "RESM-STUD"
         */
        AccommodationArticleCode: string | null;
        /**
         * The age of the person.
         * @format int32
         * @example 20
         */
        Age: number;
        /**
         * The gender of the person. Accepted values: Male, Female, Other
         * @example "Male"
         */
        Gender: string | null;
        /**
         * The destination location code.
         * @example "US-BOI"
         */
        DestinationCode: string | null;
        /**
         * The start date of the accommodation period in YYYY-MM-DD format.
         * @format date
         * @example "2024-05-01"
         */
        StartDate: string;
        /**
         * The end date of the accommodation period in YYYY-MM-DD format.
         * @format date
         * @example "2024-05-15"
         */
        EndDate: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<EventResponseDto, ProblemDetails>({
        path: `/accommodation-capacity`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  reservations = {
    /**
     * No description
     *
     * @tags Events
     * @name EventsDelayedPayment
     * @summary Sending a reservation Event to Juno for a specific quote.
     * @request POST:/reservations
     * @secure
     */
    eventsDelayedPayment: (data: EventRequestDto, params: RequestParams = {}) =>
      this.request<EventResponseDto, ProblemDetails>({
        path: `/reservations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  marketSettings = {
    /**
     * No description
     *
     * @tags MarketSettings
     * @name MarketSettingsGetMarketSettings
     * @summary Get market settings for a quote by its external id (UUID).
     * @request GET:/MarketSettings
     * @secure
     */
    marketSettingsGetMarketSettings: (
      query?: {
        /**
         * Quote's external id (guid)
         * @format guid
         */
        quoteUuid?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<MarketSettingsInfo, ProblemDetails>({
        path: `/MarketSettings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  payments = {
    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsInitiateOraclePaymentSession
     * @summary Request for initiating a payment session for a quote.
     * @request POST:/payments/initiate
     * @secure
     */
    paymentsInitiateOraclePaymentSession: (data: InitiateOraclePaymentSessionRequestDto, params: RequestParams = {}) =>
      this.request<InitiateOraclePaymentSessionResponseDto, ProblemDetails | void>({
        path: `/payments/initiate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsGetPaymentDetails
     * @summary Request for retrieving payment details.
     * @request GET:/payments
     * @secure
     */
    paymentsGetPaymentDetails: (
      query?: {
        /** @format guid */
        correlationId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaymentDetailsResponseDto, ProblemDetails | void>({
        path: `/payments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsGetPaymentOptions
     * @summary Request for retrieving available payment options.
     * @request GET:/payments/options
     * @secure
     */
    paymentsGetPaymentOptions: (
      query?: {
        /** @format guid */
        QuoteDraftUuid?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaymentOptionsResponseDto, ProblemDetails | void>({
        path: `/payments/options`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  api = {
    /**
     * @description The process of creating a preview for quote draft includes PDF generation of the quote only - quote is neither saved, nor published to the CRM and BI systems. **Notes** - each quote is evaluated using rule engine which might add/remove some mandatory sales items (not being part of the quote draft) to the quote before saving it - each quote is being validated using rule engine before being saved - should a request contain extra durations for the quote - quotes with extra durations will appear in the generated PDF for the reference/comparison with the first one
     *
     * @tags Quote
     * @name QuotePreviewQuotes
     * @summary Creates the preview for the provided quotes.
     * @request POST:/api/v1/Quote/preview
     * @secure
     */
    quotePreviewQuotes: (data: PreviewQuotesRequest, params: RequestParams = {}) =>
      this.request<GenerateQuotesResponse, ProblemDetails>({
        path: `/api/v1/Quote/preview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **The process of creating a quote includes:** - PDF generation of the quote - publishing the quote to CRM and BI systems - saving the quote to the database **Notes** - each quote is evaluated using rule engine which might add/remove some mandatory sales items (not being part of the quote draft) to the quote before saving it - each quote is being validated using rule engine before being saved - should a request contain extra durations for the quote - there will be just the first quote saved in the database and published to external systems; quotes with extra durations will appear in the generated PDF for the reference/comparison with the first one
     *
     * @tags Quote
     * @name QuoteCreateQuotes
     * @summary Creates provided quotes.
     * @request POST:/api/v1/Quote/create
     * @secure
     */
    quoteCreateQuotes: (data: CreateQuotesRequest, params: RequestParams = {}) =>
      this.request<GenerateQuotesResponse, ProblemDetails>({
        path: `/api/v1/Quote/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteGetQuote
     * @request GET:/api/v1/Quote/{externalId}
     * @secure
     */
    quoteGetQuote: (externalId: string, params: RequestParams = {}) =>
      this.request<Quote, ProblemDetails>({
        path: `/api/v1/Quote/${externalId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesItems
     * @name SalesItemsGetSalesItems
     * @request GET:/api/v1/SalesItems
     * @secure
     */
    salesItemsGetSalesItems: (
      query?: {
        GroupCode?: string | null;
        GroupSku?: string | null;
        MainAccommodationType?: SalesItemSubType | null;
        Market?: string | null;
        Program?: string | null;
        Brochure?: string | null;
        Season?: string | null;
        Destination?: string | null;
        Currency?: string | null;
        CourseSku?: string | null;
        CourseType?: string | null;
        DeparturePoint?: string | null;
        Language?: string | null;
        Sku?: string | null;
        /** @format int32 */
        Quantity?: number;
        /** @format date-time */
        StartDate?: string | null;
        /** @format date-time */
        EndDate?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<LineItem3[], ProblemDetails>({
        path: `/api/v1/SalesItems`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesItems
     * @name SalesItemsPostSalesItem
     * @request POST:/api/v1/SalesItems
     * @secure
     */
    salesItemsPostSalesItem: (data: PostSalesItemsRequest, params: RequestParams = {}) =>
      this.request<PostSalesItemsResponse, ProblemDetails>({
        path: `/api/v1/SalesItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  quote = {
    /**
     * No description
     *
     * @tags Quote
     * @name QuoteGetReservationPrice
     * @summary Request for reservation price of a quote draft
     * @request GET:/quote/reservation-price/{externalId}
     * @secure
     */
    quoteGetReservationPrice: (externalId: string, params: RequestParams = {}) =>
      this.request<ReservationPriceResponse, ProblemDetails>({
        path: `/quote/reservation-price/${externalId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  quoteDrafts = {
    /**
     * No description
     *
     * @tags QuoteDrafts
     * @name QuoteDraftsGetCourseIntensityUpgrade
     * @summary Get course intensity upgrade with a new sku and prices
     * @request GET:/quote-drafts/{id}/course-intensity-upgrade
     * @secure
     */
    quoteDraftsGetCourseIntensityUpgrade: (id: string, params: RequestParams = {}) =>
      this.request<GetCourseIntensityUpgradeResponse, ProblemDetails>({
        path: `/quote-drafts/${id}/course-intensity-upgrade`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuoteDrafts
     * @name QuoteDraftsGetDurationUpgrades
     * @summary Get quote draft duration upgrades with new prices
     * @request GET:/quote-drafts/{id}/duration-upgrades
     * @secure
     */
    quoteDraftsGetDurationUpgrades: (
      id: string,
      query?: {
        /** Weeks list to extend the duration of a quote draft */
        WeeksList?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<DurationUpgradesQuoteDraftResponse, ProblemDetails>({
        path: `/quote-drafts/${id}/duration-upgrades`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuoteDrafts
     * @name QuoteDraftsUpdateQuoteDraft
     * @summary Patch quote draft
     * @request PATCH:/quote-drafts/{id}
     * @secure
     */
    quoteDraftsUpdateQuoteDraft: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<Quote2, ProblemDetails>({
        path: `/quote-drafts/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuoteDrafts
     * @name QuoteDraftsCalculateGroupPrices
     * @summary Calculates group price for the provided group, course and default departure point
     * @request POST:/quote-drafts/group-price/calculate
     * @secure
     */
    quoteDraftsCalculateGroupPrices: (data: GroupPriceCalculationRequest, params: RequestParams = {}) =>
      this.request<GroupPriceCalculationResponse, ProblemDetails>({
        path: `/quote-drafts/group-price/calculate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  quotes = {
    /**
     * No description
     *
     * @tags Quotes
     * @name QuotesGetQuotes
     * @summary Request for returning price quote list.
     * @request GET:/Quotes
     * @secure
     */
    quotesGetQuotes: (
      query: {
        /** @format guid */
        opportunityId: string;
        /**
         * Start index of items to be retrieved
         * @format int32
         */
        offset?: number;
        /**
         * Count of items to be retrieved. Parameter is within the range of 1-50
         * @format int32
         * @min 1
         * @max 50
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<Quote2[], ProblemDetails>({
        path: `/Quotes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quotes
     * @name QuotesGetQuoteDraft
     * @summary Get a quote draft for a quote by its external id
     * @request GET:/Quotes/{externalId}/draft
     * @secure
     */
    quotesGetQuoteDraft: (externalId: string, params: RequestParams = {}) =>
      this.request<Quote2, ProblemDetails>({
        path: `/Quotes/${externalId}/draft`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quotes
     * @name QuotesSaveQuote
     * @summary Request for saving a new quote.
     * @request POST:/Quotes/{id}
     * @secure
     */
    quotesSaveQuote: (id: string, params: RequestParams = {}) =>
      this.request<Quote2, ProblemDetails>({
        path: `/Quotes/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  residenceAccommodationCapacity = {
    /**
     * @description This endpoint makes one call to salesforce to get all active for capacity calculation articles related to specified residence. Then for every article it makes calls to retrieve data for the specified date range, gender, and age and returns statuses per week per article. This API returns errorMessage and status Unknown in case there was an error in figuring out the capacity status.
     *
     * @tags ResidenceAccommodations
     * @name ResidenceAccommodationsGetResidenceCapacity
     * @summary Provides accommodation capacity status for given gender, age and residence per weeks.
     * @request GET:/residence-accommodation-capacity
     * @secure
     */
    residenceAccommodationsGetResidenceCapacity: (
      query: {
        /**
         * The age of the person.
         * @format int32
         * @example 20
         */
        Age: number;
        /**
         * The gender of the person. Accepted values: Male, Female, Other
         * @example "Male"
         */
        Gender: string | null;
        /**
         * The start date of the accommodation period in YYYY-MM-DD format.
         * @format date
         * @example "2024-05-01"
         */
        StartDate: string;
        /**
         * The end date of the accommodation period in YYYY-MM-DD format.
         * @format date
         * @example "2024-05-15"
         */
        EndDate: string;
        /**
         * The Residence code.
         * @example "RESS-DOTC"
         */
        ResidenceCode: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ResidenceAccommodationCapacityResponseDto, ProblemDetails>({
        path: `/residence-accommodation-capacity`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  installments = {
    /**
     * No description
     *
     * @tags Installments
     * @name GetInstalltments
     * @summary Provides installments' information for the given quote UUID. Includes the information about availability of the pay in full feature.
     * @request GET:/installments/{externalId}
     * @secure
     */
    getInstalltments: (externalId: string, params: RequestParams = {}) =>
      this.request<InstallmentsResponseDto, ProblemDetails>({
        path: `/installments/${externalId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
